<template>
  <div
    class="choice"
    :style="{'background-image': 'url(' + bg + ')'}">
    <div class="panel">
      <div
        class="list-item"
        v-for="(item,index) in list"
        :key="index">
        <div class="title">
          {{ item }}
        </div>
        <div
          class="btn"
          @click="disable=true">
          支付 10 元阅读
        </div>
      </div>
    </div>
    <div
      class="dialog"
      v-show="disable">
      <div
        class="dialog-item"
        :style="{'background-image': 'url(' + weixin + ')'}">
        <div
          class="close"
          @click="disable=false">
          <img
            style="width:16px;"
            src="../../assets/close.png"
            alt="">
        </div>
        <div
          class="submit"
          @click="disable=false"></div>
      </div>
    </div>
  </div>
</template>
<script>
import bg from '@/assets/bg.png'
import weixin from '@/assets/weixin.png'
export default {
  props: {},

  components: {},

  mixins: [],

  data () {
    return {
      bg,
      weixin,
      list: [
        '2020 全球时尚产业重要财报汇总',
        '探索希腊和乌克兰的别致风情：Louis Vuitton 2020 秋季旅游摄影集',
        'IG We Love：从实验性服饰到复古时装画，時尚迷不容错过的 3 个灵魂账号',
        '2021 春夏服装系列报道：Peter Do 极具「适应性」的设计语录',
        '以大胆混搭碰撞出全新主张：Converse Rivals 系列全新登场',
        '披上浪漫光彩的知性女子群像：3 位时尚插画家',
        '2021 春夏时装周系列报道：一抹清新奶油白，Mark Kenly Domino Tan 堆叠洗练形象',
        '从细节处装点居家品味，Dior Maison 释出全新 Dioriviera 系列'
      ],
      disable: false
    }
  },

  computed: {},

  watch: {},

  created () {},

  mounted () {},

  methods: {}
}
</script>
<style scoped>
.choice {
  background-size: cover;
  background-position: center;
  padding: 100px 0;
  margin-bottom: 200px;
}
.panel {
  box-sizing: border-box;
  padding: 40px 100px 80px 100px;
  background-color: white;
  margin: 0 20.834% 0 18.854%;
}
.list-item {
  height: 100px;
  display: flex;
  border-bottom: 1px solid #e9e9e9;
  align-items: center;
  font-size: 14px;
}
.title {
  flex: 1 1 auto;
}
.btn {
  cursor: pointer;
  background-color: #41b6e6;
  color: white;
  padding: 8px 26px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  flex: 0 0 auto;
}
.dialog {
  position: fixed;
  top: 0;
  bottom: 0;
  width: 100%;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.dialog-item {
  width: 500px;
  height: 568px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top;
  margin: 0 auto;
  position: relative;
}
.close {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}
.submit {
  position: absolute;
  bottom: 95px;
  width: 110px;
  height: 29px;
  left: 194px;
  cursor: pointer;
}
</style>
